"use client";

import { Link } from "@tanstack/react-router";
import { type LucideIcon } from "lucide-react";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { type FileRoutesByTo } from "@/routeTree.gen";

export type NavItem = {
  title: string;
  url: keyof FileRoutesByTo;
  icon?: LucideIcon;
  isActive?: boolean;
  isVisible?: boolean;
};

export function NavItems({ items }: { items: NavItem[] }) {
  return (
    <SidebarMenu>
      {items.map((item) => (
        <SidebarMenuItem key={item.title}>
          <Link to={item.url}>
            {({ isActive }: { isActive: boolean }) => {
              return (
                <SidebarMenuButton className="h-10" tooltip={item.title} isActive={isActive}>
                  {item.icon && <item.icon />}
                  <span>{item.title}</span>
                </SidebarMenuButton>
              );
            }}
          </Link>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
}
